import { IXM_USERAUTH_V1_PROGRAM_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixm-userauth-v1-program-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxmUserauthV1ProgramStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface ProgramStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxmUserauthV1ProgramStatus | undefined;
}

export function ProgramStatusPill({ isPending, status, ...props }: ProgramStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXM_USERAUTH_V1_PROGRAM_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixmUserauthV1', enumName: 'IxmUserauthV1ProgramStatus', value: status }} />
    </Pill>
  );
}
